


/**
* The type that a photo tag is
*/
export enum TagType{
    /**
    * Not bad nor good, but good information to know
    */
    Information = 0,
    /**
    * Possible risk or hazard
    */
    Warning = 1,
    /**
    * An item that has potential to reduce risk and perhaps premium
    */
    Credit = 2
}

